import { createFileRoute } from "@tanstack/react-router";

import { SignInScreen } from "@/components/site/AuthScreens";

const title = "Logga in | Swedish International School";
const description = "Inloggning för skolans personal och administratörer.";

export const Route = createFileRoute("/auth")({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    ...(typeof search["redirect"] === "string" && search["redirect"].startsWith("/") ? { redirect: search["redirect"] } : {}),
  }),
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: AuthPage,
});

function AuthPage() {
  const { redirect } = Route.useSearch();
  return <SignInScreen locale="sv" {...(redirect ? { destination: redirect } : {})} />;
}
